import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Divider');
const Divider = _ref => {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const override = getOverrides(overridesProp, Divider.overrides);
  const rootProps = useMemo(() => ({
    ...props,
    className: classNames(classes.root, classNameProp)
  }), [classNameProp, classes.root, props]);
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root));
};
Divider.overrides = ['root'];
process.env.NODE_ENV !== "production" ? Divider.propTypes = {
  /** Custom CSS class for styling the divider */
  className: PropTypes.string,
  /** Object with custom style overrides for the root element */
  overrides: PropTypes.object
} : void 0;
export default /*#__PURE__*/memo(Divider);